export default __webpack_public_path__ + "static/media/kakao.565ef247.svg";